import AllTickets from "@containers/Tickets/AllTickets";
import AssignedTickets from "@containers/Tickets/AssignedTickets";
import CreateTicket from "@containers/Tickets/CreateTicket";
import MyTickets from "@containers/Tickets/MyTickets";
import RequestedTickets from "@containers/Tickets/RequestedTickets";
import TicketDetails from "@containers/Tickets/TicketDetails";
import TicketSettings from "@containers/Tickets/TicketSettings";
import NoMatch from "@containers/no-match";

import { ROUTES } from "@constants/routes";
import { RouteType } from "./types";

const {
  CREATE,
  ID,
  TICKETS: {
    E_TICKETS,
    MY_TICKETS,
    REQUESTED_TICKETS,
    ASSIGNED_TICKETS,
    SETTINGS,
  },
} = ROUTES;

export const TicketsRoutes: RouteType[] = [
  // E_TICKETS MODULE
  {
    id: "ticket_list",
    path: E_TICKETS,
    children: [
      {
        id: "ticket_list_index",
        index: true,
        element: <AllTickets />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_HEAD",
        },
      },
      {
        id: "ticket_create",
        path: CREATE,
        element: <CreateTicket />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_HEAD",
        },
      },
      {
        id: "ticket_details",
        path: ID,
        element: <TicketDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_HEAD",
        },
      },
    ],
  },
  {
    id: "my_ticket_list",
    path: MY_TICKETS,
    children: [
      {
        id: "my_ticket_list_index",
        index: true,
        element: <MyTickets />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "E_TICKET_VIEW_MY_TICKET",
        },
      },
      {
        id: "my_ticket_create",
        path: CREATE,
        element: <CreateTicket />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "E_TICKET_EDIT_MY_TICKET",
        },
      },
      {
        id: "my_ticket_details",
        path: ID,
        element: <TicketDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "E_TICKET_VIEW_MY_TICKET",
        },
      },
    ],
  },
  {
    id: "requested_ticket_list",
    path: REQUESTED_TICKETS,
    children: [
      {
        id: "requested_ticket_list_index",
        index: true,
        element: <RequestedTickets />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_HEAD",
        },
      },
      {
        id: "requested_ticket_create",
        path: CREATE,
        element: <CreateTicket />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_HEAD",
        },
      },
      {
        id: "requested_ticket_details",
        path: ID,
        element: <TicketDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_HEAD",
        },
      },
    ],
  },
  {
    id: "assigned_ticket_list",
    path: ASSIGNED_TICKETS,
    children: [
      {
        id: "assigned_ticket_list_index",
        index: true,
        element: <AssignedTickets />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_EMPLOYEE",
        },
      },
      {
        id: "assigned_ticket_create",
        path: CREATE,
        element: <CreateTicket />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_EMPLOYEE",
        },
      },
      {
        id: "assigned_ticket_details",
        path: ID,
        element: <TicketDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_EMPLOYEE",
        },
      },
    ],
  },

  //SETTINGS MODULE
  {
    id: "settings_module",
    path: SETTINGS,
    children: [
      {
        id: "settings",
        index: true,
        element: <TicketSettings />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "IT_HEAD",
        },
      },
    ],
  },
];
